<template>
  <div>
    <div class="vx-row">
      <!-- MULTIPLE COLUMNS-->
      <div class="vx-col w-full mb-base">
        <vs-card title="">
          <b-row>
            <b-col cols="12" style=" padding-right: 20px">
              <b-row align-h="start" align-v="end">
                <b-col>
                  <b-row>
                    <b-col cols="8">
                      <b-form-group label="Raporlar" label-for="item-name">
                        <v-select v-model="raporListSecilen" :options="raporList" label="baslik" style="">
                        </v-select></b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group label="Yıl" label-for="item-name">
                        <v-select v-model="secilenDurum" :options="durumList" label="name" :placeholder="todayYear"
                          style="" @input="yilDeger()">
                        </v-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Başlangıç Tarihi" label-for="item-name">
                    <b-form-datepicker bottom v-model="datepickerbaslangic" placeholder="-" size="md" local="tr-TR"
                      today-variant="danger" :start-weekday="weekday" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }" />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Bitiş Tarihi" label-for="item-name">
                    <b-form-datepicker bottom v-model="datepickerbitis" placeholder="-" size="md" local="tr-TR"
                      today-variant="danger" :start-weekday="weekday" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      }" />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Arama" label-for="item-name">
                    <b-form-input v-model="aranan" id="smallInput" placeholder="Aranan" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="auto"><vs-button style="border-radius: 5px" color="danger" @click="finansListele()"
                    id="button-with-loading-yeni" class="vs-con-loading__container" type="gradient">Listele</vs-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <div class="demo-alignment"></div>
        </vs-card>
        <div class="mt-5">
          <vs-card>
            <vs-tabs alignment="fixed" v-model="tabIndex">
              <vs-tab label="Liste">

                <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
                  :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowdata" :localeText="localeText"
                  @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered">
                </ag-grid-vue>

              </vs-tab>
              <vs-tab label="Grafik"
                v-if="raporListSecilen.baslik == 'Stok-Aylık Tonaj' || raporListSecilen.baslik == 'Stok-Aylık Stok Durumu'">
                <div>
                  <vue-apex-charts type="area" height="350" :options="lineAreaChartSpline.chartOptions"
                    :series="lineAreaChartSpline.series"></vue-apex-charts>
                </div>
              </vs-tab>
              <vs-tab label="Grafik" v-else>
                <div>

                </div>
              </vs-tab>

            </vs-tabs> </vs-card>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import state from "../../store/state";
import Store from "../../store/store";
import { tr } from "vuejs-datepicker/dist/locale/";
import { BFormDatepicker } from "bootstrap-vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import VueApexCharts from "vue-apexcharts";

export default {
  data() {
    return {
      tabIndex: 0,
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
      lineAreaChartSpline: {},
      todayYear: "",
      durumList: [],
      secilenDurum: "",
      aranan: "",
      datepickerbitis: "",
      datepickerbaslangic: "",
      weekday: 1,
      raporListSecilen: "",
      pazaryeriSecilen: "",
      raporList: [],
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: [],
      localeText: null,
      rowdata: null,
      currentTabMarketplace: "",
      gridApi: null
    };
  },
  methods: {
    getYears() {
      const today = new Date();
      const a = new Date(today);

      for (let index = a.getFullYear(); index >= 2014; index--) {
        this.durumList.push({
          name: index,
          val: index
        });
      }
    },
    onFirstDataRendered(params) {
      if (!this.raporListSecilen.baslik.trimEnd() == "Fatura-Bu Gün yapılan Satışlar")

        params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    finansmanCek(sayfasayisi) {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      if (
        vm.pazaryeriSecilen.name == "" ||
        typeof vm.pazaryeriSecilen.name == "undefined"
      ) {
        vs.notify({
          title: "Trendyol Finansman",
          text: "Pazaryeri seçimi yapınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        const args = {
          pazaryeri: vm.pazaryeriSecilen.name
        };
        soap.createClient(url, function (err, client) {
          client.FinansVeri(args, function (err, result) {
            try {
              vm.veriler = JSON.parse(result.FinansVeriResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading > .con-vs-loading");
              } else {
                vs.loading.close("#button-with-loading > .con-vs-loading");
                vs.notify({
                  title: "Trendyol Finansman",
                  text: "Veriler Çekilemedi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center"
                });
              }
            } catch (error) {
              vs.loading.close("#button-with-loading > .con-vs-loading");
              vs.notify({
                title: "Trendyol Finansman",
                text: "Veriler Çekilemedi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center"
              });
            }
          });
        });
      }
    },
    raporListesi() {
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId
      };
      soap.createClient(url, function (err, client) {
        client.raporBaslik(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.raporBaslikResult);
            vm.raporList = vm.veriler;
          } catch (error) { }
        });
      });
    },

    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    finansListele() {
      const vs = this.$vs;
      var vm = this;
      vm.tabIndex = 0;

      vm.finansList = [];
      vm.rowdata = [];
      vm.columnDefs = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      vs.loading({
        background: "#EA5455",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45
      });
      const args = {
        token: Store.state.tokenId,
        aranan: vm.aranan,
        ilkTarih: vm.datepickerbaslangic,
        sonTarih: vm.datepickerbitis,
        baslik: vm.raporListSecilen.baslik,
        program: vm.pazaryeriSecilen.name,
        yil: vm.secilenDurum.val
      };
      soap.createClient(url, function (err, client) {
        client.raporlar(args, function (err, result) {
          try {
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            vm.veriler = JSON.parse(result.raporlarResult);
            let list = vm.veriler;
            let columnList = Object.keys(list[0]);
            let bugunSatislarChildren = [
              {
                columnGroupShow: "close",
                width: 50,
              }
            ];
            let farklıFiyataSatislarChildren = [
              {
                columnGroupShow: "close",
                width: 50,
              }
            ]

            columnList.forEach((val, index) => {
              if (vm.raporListSecilen.baslik.trimEnd() == "Fatura-Bu Gün yapılan Satışlar") {
                if (val == 'Cari Adı' || val == 'Stok No' || val == 'Stok Adı' || val == 'Kar Oranı') {

                  vm.columnDefs.push({ field: val, filter: "agSetColumnFilter", pinned: "left" });

                } else {
                  bugunSatislarChildren.push({
                    headerName: val,
                    field: val, filter: "agSetColumnFilter",
                    cellRenderer: "TextGorunumCellRenderer",
                    filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                    wrapText: true,
                    columnGroupShow: "open",
                  })

                }
              } else if (vm.raporListSecilen.baslik.trimEnd() == "Fatura-Farklı Fiyata Satışlar") {
                if (val == 'Cari Adı' || val == 'Stok No' || val == 'Stok Adı' || val == 'Fiyat' || val == 'Döviz' || val == 'Satış Fiyatı'
                  || val == 'Döviz2' || val == 'İndirim Oranı'
                ) {
                  if (val.includes("Döviz"))
                    vm.columnDefs.push({ field: val, filter: "agSetColumnFilter", pinned: "left", width: 50, });
                  else if (val.includes("Fiyat"))
                    vm.columnDefs.push({ field: val, filter: "agSetColumnFilter", pinned: "left", width: 100, });
                  else
                    vm.columnDefs.push({ field: val, filter: "agSetColumnFilter", pinned: "left" });

                } else {
                  if (val.toUpperCase().includes("TARİH") || val.toUpperCase().includes("TARIH") || val.toUpperCase().includes("VADE")) {

                    farklıFiyataSatislarChildren.push({
                      headerName: val,
                      field: val, filter: "agSetColumnFilter",
                      cellRenderer: "TextGorunumCellRenderer",
                      filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                      wrapText: true,
                      columnGroupShow: "open",
                      valueFormatter: vm.parseDate,
                    })

                  } else
                    farklıFiyataSatislarChildren.push({
                      headerName: val,
                      field: val, filter: "agSetColumnFilter",
                      cellRenderer: "TextGorunumCellRenderer",
                      filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
                      wrapText: true,
                      columnGroupShow: "open",
                    })

                }
              }
              else {
                if (val.toUpperCase().includes("TARİH") || val.toUpperCase().includes("TARIH") || val.toUpperCase().includes("VADE")) {

                  vm.columnDefs.push({ field: val, filter: "agSetColumnFilter", valueFormatter: vm.parseDate, });

                } else {
                  vm.columnDefs.push({ field: val, filter: "agSetColumnFilter" });

                }
              }

            });
            if (vm.raporListSecilen.baslik.trimEnd() == "Fatura-Bu Gün yapılan Satışlar" || vm.raporListSecilen.baslik.trimEnd() == "Fatura-Farklı Fiyata Satışlar") {
              vm.columnDefs.push({
                headerName: "Detay",
                children: vm.raporListSecilen.baslik.trimEnd() == "Fatura-Bu Gün yapılan Satışlar" ? bugunSatislarChildren : farklıFiyataSatislarChildren,
              });
            }
            console.log(vm.columnDefs)
            vm.finansList = vm.veriler;
            vm.rowdata = list;
            let chartSeries = []
            let chartCategories = [], chartAdet = [], chartBilgisayarKg = [], chartOlculen = [], lineAreaChartSpline = {};
            let categoriesVal = Object.keys(vm.rowdata[0])

            if (vm.raporListSecilen.baslik == "Stok-Aylık Tonaj") {
              vm.rowdata.forEach((val, index) => {
                chartCategories.push(val.YIL + "-" + val.AY)
                chartAdet.push(val.Adet.toFixed(2));
                chartBilgisayarKg.push(val["Bilgisayar Kg"].toFixed(2))
                chartOlculen.push(val["Ölçülen Kg"].toFixed(2))
              });
              let chartAdetFor = {
                name: "Adet",
                data: chartAdet
              };
              let chartBilgisayarFor = {
                name: "Bilgisayar Kg",
                data: chartBilgisayarKg
              };
              let chartOlculenFor = {
                name: "Ölçülen Kg",
                data: chartOlculen
              }
              vm.lineAreaChartSpline = {
                series: [chartAdetFor, chartBilgisayarFor, chartOlculenFor],
                chartOptions: {
                  dataLabels: {
                    enabled: false
                  },
                  stroke: {
                    curve: 'smooth'
                  },
                  colors: vm.themeColors,
                  xaxis: {
                    categories: chartCategories,
                  },
                  tooltip: {
                    x: {
                      format: 'dd/MM/yy HH:mm'
                    },

                  }
                }
              };
            } else if (vm.raporListSecilen.baslik == "Stok-Aylık Stok Durumu") {
              vm.rowdata.forEach((val, index) => {
                chartCategories.push(val.YIL + "-" + val.AY)
                chartAdet.push(val.ADET.toFixed(2));
              });
              let chartAdetFor = {
                name: "Adet",
                data: chartAdet
              };

              vm.lineAreaChartSpline = {
                series: [chartAdetFor],
                chartOptions: {
                  dataLabels: {
                    enabled: false
                  },
                  stroke: {
                    curve: 'smooth'
                  },
                  colors: vm.themeColors,
                  xaxis: {
                    categories: chartCategories,
                  },
                  tooltip: {
                    x: {
                      format: 'dd/MM/yy HH:mm'
                    },

                  }
                }
              };
            }
            vm.$nextTick(() => {
              if (!vm.raporListSecilen.baslik.trimEnd() == "Fatura-Bu Gün yapılan Satışlar")
                vm.gridApi.sizeColumnsToFit();
            });
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }


        });
      });
    }
  },
  created() {
    const today = new Date();
    const a = new Date(today);
    this.todayYear = a.getFullYear().toString();
    this.secilenDurum = { val: this.todayYear, name: this.todayYear }
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getYears();
    this.raporListesi();
  },
  components: {
    VueApexCharts,
    AgGridVue,
    "v-select": vSelect,
    Datepicker,
    BFormDatepicker
  }
};
</script>
